var exports = {
  "D9": "latestStatusUpdate__L42U36",
  "sR": "RelativeTime__hSXiwM",
  "aZ": "SingleSelectToken__foDSM0",
};

module.exports = exports;
